<template>
    <el-dialog :visible.sync="show"
               title="扫码支付"
               width="300px"
               custom-class="qrpay yx-center"
               :lock-scroll="true"
               @closed="payWaiting=false"
    >
        <div class="yx-center">
            <div ref="qrcode" v-loading="qrLoading" class="qrcode">
            </div>
            <div v-if="payMethod === 'weixin'" class="weixin-tip font-size18 c-868EA1">
                微信扫一扫立即支付
            </div>
        </div>
    </el-dialog>
</template>
<script>
import { sleep } from "@/utils";
import { PayOrderStatus, wxPayPc } from "@/api/user";

/**
     * 事件列表：
     *      - pay-success [orderId] 支付成功，参数为产品id
     *      - timeout 支付超时
     */
export default {
    name: "PayDialog",
    data() {
        return {
            show: false,
            payMethod: "",
            qrLoading: false,
            payWaiting: false
        };
    },
    methods: {
        /**
             * 发起支付
             * @param orderId 产品id
             * @param method 支付方式 支持 weixin
             */
        async payOrder(orderId, method, descript) {
            this.payMethod = method;
            this.qrLoading = true;
            this.show = true;
            const signObj = await this.getPaySign(orderId, method, descript);
            if (method === "weixin") {
                await this.weixinPay(signObj);
            } else {
                this.show = false;
                this.$message.error("暂未支持此支付方式：" + method);
                return;
            }
            const success = await this.waitOrder(signObj);
            if (success) {
                this.show = false;
                this.$emit("pay-success", orderId);
            }
        },
        async getPaySign(orderId, method, descript) {
            if (method === "weixin") {
                return wxPayPc({
                    Id: orderId,
                    descript
                }).then(data => {
                    return {
                        orderNo: data.data.msg,
                        data: data.data.data
                    }
                })
            }
        },
        async weixinPay(sign) {
            this.$refs.qrcode.innerHTML = "";
            const QRCode = require("qrcodejs2");
            const qrCode = new QRCode(this.$refs.qrcode, {
                text: sign.data,
                width: 200,
                height: 200,
                colorDark: "#000000",
                colorLight: "#ffffff"
            });
            this.qrLoading = false;
        },
        async aliPay(sign) {
            console.log(sign);
        },
        /**
             * 等待订单状态变成功，超时后返回失败
             * @return {Promise<boolean>}
             */
        async waitOrder(signObj) {
            let startT = new Date();
            this.payWaiting = true;
            const timeout = 1000 * 60 * 10; // 10分钟超时
            let success = false;
            while (this.payWaiting) {
                let order;
                try {
                    order = await PayOrderStatus({
                        orderNo: signObj.orderNo
                    });
                } catch (e) {
                    console.error("查询支付状态失败,5秒后重试");
                    await sleep(5000);
                    continue
                }
                if (order.data.code === 100) {
                    this.payWaiting = false;
                    success = true;
                } else {
                    let useT = new Date() - startT;
                    if (useT > timeout) {
                        this.payWaiting = false;
                        this.$emit("timeout")
                    } else {
                        await sleep(5000);
                    }
                }
            }
            return success;
        }
    }
};
</script>

<style scoped lang="less">
.qrcode {
    width: 200px;
    height: 200px;
    ::v-deep canvas {
        display: none;
    }
    ::v-deep img {
        width: 100%;
    }
}

.weixin-tip {
    margin-top: 30px;
}

.qrpay {

}
</style>
